export default [
    {
        "error_id": "ENCR-01",
        "data": [
            {
                "cross_section": "43827",
                "error_id": "ENCR-04",
                "side": "Right",
                "issue": "encroachment station is on the left bank."
            },
            {
                "cross_section": "42062",
                "error_id": "ENCR-02",
                "left": false,
                "right": true,
                "side": "Right",
                "issue": "within channel"
            },
            {
                "cross_section": "41697",
                "error_id": "ENCR-01",
                "left": true,
                "right": false,
                "side": "Left",
                "issue": "outside of the floodplain"
            }
        ]
    }
]